import { computeDateParams } from '@modules/consolidator/utils/string-build/build-asset-statistics-url'

export const formatDateFilterLabel = ({
  filtroData,
  dataInicio,
  dataFim,
  dateFactory,
} = {}) => {
  if (!filtroData) return ''

  const params = computeDateParams({
    filtroData,
    dataInicio,
    dataFim,
    dateFactory,
  })
  const begin = toLabelDate(params.begin_date)
  const end = toLabelDate(params.end_date)

  if (begin && end) return `${filtroData} (${begin} → ${end})`
  if (begin) return `${filtroData} (Início: ${begin})`
  if (end) return `${filtroData} (Fim: ${end})`
  return filtroData
}

const toLabelDate = (value) => {
  if (!value) return ''
  return value.replaceAll('-', '/')
}
